import { Badge } from '../../components/ui/Badge'
import { SubscriptionTier } from '../../types/auth'

const PLANS: Record<SubscriptionTier, { label: string; color: 'gray' | 'amber' | 'purple' }> = {
  free: { label: 'Free', color: 'gray' },
  plus: { label: 'Plus', color: 'amber' },
  pro: { label: 'Pro', color: 'purple' },
}

export function PlanBadge({ tier }: { tier: SubscriptionTier | undefined }) {
  const plan = PLANS[tier ?? 'free'] ?? PLANS.free
  return <Badge color={plan.color}>{plan.label}</Badge>
}
